import { RefObject, useEffect } from 'react';

type FunctionName = () => void;
const useWithClickOutside = (
  ref: RefObject<HTMLInputElement>,
  onClickOutside: FunctionName
) => {
  useEffect(() => {
    function onHandleClickOutside(event: Event) {
      const target = event.target as HTMLInputElement;
      if (ref.current && !ref.current.contains(target)) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', onHandleClickOutside);
    return () => {
      document.removeEventListener('mousedown', onHandleClickOutside);
    };
  }, [ref, onClickOutside]);
};
export default useWithClickOutside;
